import React, { Component } from "react";
import { connect } from "react-redux";
import SidebarList from "features/Admin/components/SidebarList";
import ElementFocus from "features/Admin/components/ElementFocus";
import {
	adminGetCancelReason,
	adminGetAllCancelReasons,
	resetFocusCancelReason,
	initNewCancelReason,
	adminPatchCancelReason,
	adminPostCancelReason,
	adminDeleteCancelReason,
	adminGetCancelReasonGroups,
} from "services/cancelReason";
import AdminDataContainer from "features/Admin/components/AdminDataContainer";
import { Grid, Icon } from "semantic-ui-react";
import RedButton from "components/Buttons/RedButton";
import GeneralForm from "features/Admin/CancelReasons/Forms/GeneralForm";
import { Form, Formik } from "formik";
import MainButton from "components/Buttons/MainButton";
import SecondaryButton from "components/Buttons/SecondaryButton";
import * as Yup from "yup";

const schemaValidation = Yup.object().shape({
	label: Yup.string().required("Champ requis"),
	group: Yup.string().required("Champ requis"),
	order: Yup.number().required("Champ requis"),
});

class CancelReasonsAdmin extends Component {
	componentDidMount() {
		this.getAllElements();
	}

	componentWillUnmount() {
		this.props.resetFocusCancelReason();
	}

	componentDidUpdate(prevProps, prevState, snapshot) {}

	getAllElements = () => {
		this.props.adminGetAllCancelReasons();
		this.props.adminGetCancelReasonGroups();
	};

	focusOnElement = (elt) => {
		this.props.adminGetCancelReason(elt);
	};

	onAddClick = () => {
		this.props.initNewCancelReason();
	};

	saveFocus = (values, setSubmitting) => {
		if (values.id === undefined) {
			delete values.id;
			this.props.adminPostCancelReason(values).then(() => {
				setSubmitting(false);
			});
		} else {
			this.props.adminPatchCancelReason(values).then(() => {
				setSubmitting(false);
			});
		}
	};

	deleteFocus = () => {
		this.props.adminDeleteCancelReason(this.props.cancelReasons.focus.data);
	};

	getGroupLabel = (group) => {
		switch (group) {
			case "BYSEC_FOLDER":
				return "Annulation du dossier par une secrétaire";
			case "BYSECRETARY":
				return "Annulation de la prise en charge par une secrétaire";
			case "BYNURSE":
				return "Annulation par l'infirmière";
			case "EMAILPATIENT":
				return "Raison d'envoi d'un email au patient";
			default:
				return "Général";
		}
	};
	getList = (list) => {
		return {
			...list,
			data: list.data.map((e) => {
				return { ...e, groupLabel: this.getGroupLabel(e.group) };
			}),
		};
	};

	render() {
		const { cancelReasons } = this.props;
		const { focus, list, groups } = cancelReasons;
		const cancelReason = focus.data;
		const newCancelReason = cancelReason !== null && cancelReason.id === undefined;

		return (
			<div style={styles.adminContainer}>
				<SidebarList
					list={this.getList(cancelReasons.list)}
					categories={[]}
					onElementClick={this.focusOnElement}
					entity="Raisons d'annulation"
					addButtonText="Nouvelle raison d'annulation"
					onAddButtonClick={this.onAddClick}
					defaultLabel={(e) => e.label}
					groupField="groupLabel"
					focusedEltId={cancelReason}
				/>

				<ElementFocus element={focus} list={list} entity="Raisons d'annulation d'un dossier du télésecrétariat" icon="info">
					{cancelReason !== null && (
						<Formik
							enableReinitialize
							initialValues={{
								id: cancelReason.id,
								label: cancelReason.label || "",
								group: cancelReason.group ? this.getGroupLabel(cancelReason.group) : "",
								order: cancelReason.order || 1,
							}}
							validationSchema={schemaValidation}
							onSubmit={(values, { setSubmitting }) => {
								this.saveFocus(values, setSubmitting);
							}}
						>
							{({ isSubmitting, errors }) => (
								<Form>
									<Grid style={{ margin: 0 }}>
										<Grid.Row columns={1}>
											<Grid.Column>
												<SecondaryButton type="button" style={{ float: "left" }} onClick={this.props.resetFocusCancelReason}>
													Fermer
												</SecondaryButton>
												<MainButton
													text={<Icon name="save" />}
													type="submit"
													style={{ float: "left" }}
													isSubmitting={isSubmitting}
													disabled={Object.entries(errors).length > 0 && errors.constructor === Object}
												>
													{newCancelReason ? "Créer" : "Enregistrer"}
												</MainButton>

												{!newCancelReason && (
													<RedButton
														text={<Icon name="trash" />}
														type="button"
														onClick={(e) => {
															if (e !== undefined) e.preventDefault();
															this.deleteFocus();
														}}
														style={{ float: "right" }}
													>
														Supprimer
													</RedButton>
												)}
											</Grid.Column>
										</Grid.Row>

										<Grid.Row columns={1}>
											<Grid.Column>
												<AdminDataContainer ribbonColor="red" ribbonLabel="Général">
													<GeneralForm groups={groups} getGroupLabel={this.getGroupLabel} />
												</AdminDataContainer>
											</Grid.Column>
										</Grid.Row>
									</Grid>
								</Form>
							)}
						</Formik>
					)}
				</ElementFocus>
			</div>
		);
	}
}

const styles = {
	adminContainer: {
		height: "100%",
		width: "100%",
		paddingTop: 43,
		fontSize: 0,
		display: "flex",
	},
	blocHeader: {
		backgroundColor: "rgb(0, 147, 128)",
		padding: 10,
		width: "100%",
		borderRadius: "4px 4px 0 0",
	},
};

const mapStateToProps = (state) => {
	return {
		cancelReasons: state.admin.cancelReasons,
	};
};

const mapDispatchToProps = {
	adminGetAllCancelReasons,
	adminGetCancelReason,
	adminPatchCancelReason,
	adminDeleteCancelReason,
	resetFocusCancelReason,
	adminPostCancelReason,
	initNewCancelReason,
	adminGetCancelReasonGroups,
};

export default connect(mapStateToProps, mapDispatchToProps)(CancelReasonsAdmin);
